import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { TeamMember } from '../../types/team.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { CreateTeamMemberDto } from './use-create-team-member';

export type UpdateTeamMemberDto = Partial<CreateTeamMemberDto>;

// Cross-tenant admin data — not scoped to companies/:companyId; enforced server-side by AdminPanelGuard.
export const useUpdateTeamMember = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateMember, isPending } = useAppMutation([QueryKey.UPDATE_TEAM_MEMBER], {
    mutationFn: ({ id, ...body }: { id: string } & UpdateTeamMemberDto) =>
      ApiService.patch<TeamMember, UpdateTeamMemberDto>(
        { endpoint: BackendRoute.TEAM_MEMBERS, routePath: [id] },
        { body },
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_TEAM_MEMBERS] }),
  });

  return { updateMember, isPending };
};
